/**
 * 全局配置文件
 */

// @ts-ignore
import packageInfo from '@/package.json';

const { version } = packageInfo;

/** API 基础地址 */
export let baseUrl : string;

// 开发环境配置 - 优先使用 VITE_API_DEV_URL
if (process.env.NODE_ENV === 'development') {
	baseUrl = import.meta.env.VITE_API_DEV_URL as string;
} else {
	baseUrl = import.meta.env.VITE_API_BASE_URL as string;
}

// 如果环境变量未设置，使用默认值
if (!baseUrl) {
	baseUrl = 'http://127.0.0.1:28080';
	console.warn('[配置警告] 未检测到 API 地址环境变量，使用默认地址:', baseUrl);
}

console.log(`[我要许愿望 ${version}]  https://www.wyxyw.com`);

/** API 路径 */
export const apiPath : string = (import.meta.env.VITE_API_PATH || '') as string;

/** 静态资源地址 */
export const staticUrl : string = (import.meta.env.VITE_STATIC_URL || '') as string;

/** 租户 ID */
export const tenantId : string = (import.meta.env.VITE_TENANT_ID || '1') as string;

/** 自定义字体名称（与 uni.scss 中 $font-family-custom 保持一致） */
export const customFontFamily : string = 'AlibabaPuHuiTi';

/** WebSocket 路径 */
export const websocketPath : string = (import.meta.env.VITE_WEBSOCKET_PATH || '') as string;

/** H5 地址 */
export const h5Url : string = (import.meta.env.VITE_H5_URL || window?.location?.origin || '') as string;

/** 应用版本号 */
export const appVersion : string = version;

/** 配置对象 */
export interface Config {
	baseUrl : string;
	apiPath : string;
	staticUrl : string;
	tenantId : string;
	websocketPath : string;
	h5Url : string;
	appVersion : string;
}

const config : Config = {
	baseUrl,
	apiPath,
	staticUrl,
	tenantId,
	websocketPath,
	h5Url,
	appVersion: version,
};

export default config;